import React from 'react';

/** Neutral placeholder block. Never a spinner inside content areas. */
export function Skeleton({
  className = ''
}: {
  className?: string;
}) {
  return <span aria-hidden="true" className={`block animate-pulse rounded-[8px] bg-sand-deep ${className}`} data-id="element-1318" data-mp="2q3w4il5nyx4e" />;
}

/** Skeleton shape matching a metric card pair. */
export function SkeletonCards({
  count = 2
}: {
  count?: number;
}) {
  return <div className="grid grid-cols-2 gap-2" data-id="element-1319" data-mp="22fcxsa29isef">
      {Array.from({
      length: count
    }).map((_, index) => <div key={index} className="rounded-card border border-sand-line bg-white/70 p-2" data-id="element-1320" data-mp="2785zep2fpkma" data-mpi={index}>
          <Skeleton className="h-[9px] w-2/3" data-id="element-1321" data-mp="1thkhb2kt1epg" />
          <Skeleton className="mt-2 h-[22px] w-1/2" data-id="element-1322" data-mp="1xgtao6bxnakh" />
          <Skeleton className="mt-2 h-[9px] w-full" data-id="element-1323" data-mp="1xhktshocfftv" />
        </div>)}
    </div>;
}

/** Skeleton shape matching a feed post. */
export function SkeletonPost() {
  return <div className="rounded-card border border-sand-line bg-white/70 p-2" data-id="element-1324" data-mp="1ofbn62w746lr">
      <div className="flex items-center gap-2" data-id="element-1325" data-mp="2r69fcoqnihey">
        <Skeleton className="h-[38px] w-[38px] rounded-pill" data-id="element-1326" data-mp="2r95doe6ev83x" />
        <div className="flex-1" data-id="element-1327" data-mp="2m6wirc9z9vz6">
          <Skeleton className="h-[10px] w-1/3" data-id="element-1328" data-mp="2ma26oo6vertb" />
          <Skeleton className="mt-1 h-[9px] w-1/4" data-id="element-1329" data-mp="307z5lr8srab5" />
        </div>
      </div>
      <Skeleton className="mt-2 h-[9px] w-1/2" data-id="element-1330" data-mp="2v8mgt0yd7t5x" />
      <Skeleton className="mt-2 h-[12px] w-full" data-id="element-1331" data-mp="2v9xjexg2quvg" />
      <Skeleton className="mt-2 aspect-[4/3] w-full rounded-[14px]" data-id="element-1332" data-mp="27is88vl2wqrh" />
    </div>;
}